import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import { quotasWithout50MB } from "@/config";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import Toggle from "Components/toggle/Toggle";

import DayPicker from "Components/dayPicker/DayPicker";

import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";

import t from "Utils/translation";
import s from "./limitsCustomers.scss";

export default class Limits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxEmailAccountsSelected: props.formData.max_email_accounts,
      viewFields: [
        "max_domains",
        "max_email_accounts",
        "max_email_accounts_25gb",
        "max_email_accounts_50gb",
        "max_email_accounts_100gb",
        "max_email_accounts_archive",
        "max_delivery_account_free",
        "max_email_quota",
        "catch_all",
        "is_reseller",
        "is_wholesale",
        "plan",
        "expiration",
        "can_edit_outbound_limits",
        "domain_limit_tracemail_21_days_default",
      ],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.formData.max_email_accounts !== undefined && this.props.formData.max_email_accounts === undefined) {
      this.setState({
        maxEmailAccountsSelected: nextProps.formData.max_email_accounts,
      });
    }
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  setValueAndToggleWholesale(values) {
    this.props.setFormFieldValue({ is_reseller: false, ...values });
  }

  setValueAndToggleReseller(values) {
    this.props.setFormFieldValue({ is_wholesale: false, ...values });
  }

  setMaxLimits(values) {
    this.props.setFormFieldValue(values);
    this.setState({ maxEmailAccountsSelected: values.max_email_accounts });
  }

  render() {
    const { formErrors, formData, isFormLoading, setFormFieldValue, submitForm, customer } = this.props;

    return (
      <form className={s.general} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>

          <div className={s.infoBtnGroup}>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.customerType.title")}</div>
              <div className="sectionDesc">{t("settings.sections.customerType.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Select
                label={t("input.label.select.plan")}
                components={{ DropdownIndicator }}
                name="plan"
                value={formData.plan}
                onChange={setFormFieldValue}
                clearable={false}
                options={[
                  { value: "trial", label: t("select.status.trial") },
                  { value: "paid", label: t("select.status.paid") },
                  { value: "free", label: t("select.status.free") },
                ]}
              />

              <DayPicker
                label={t("input.label.date.expiration")}
                name="expiration"
                value={formData.expiration}
                onChange={setFormFieldValue}
                initialValue={formData.expiration}
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.is.reseller")}
                name="is_reseller"
                checked={formData.is_reseller}
                onChange={this.setValueAndToggleWholesale.bind(this)}
                disabled={formData.is_wholesale}
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.is.wholesale")}
                name="is_wholesale"
                checked={formData.is_wholesale}
                onChange={this.setValueAndToggleReseller.bind(this)}
                disabled={formData.is_reseller}
              />

              <div className="flex items-center justify-between col-span-2 gap-4  text-sm text-[--text]">
                <div className="flex flex-col gap-1">
                  <label>Tipologia dichiarata al primo login</label>
                  <p className="text-xs text-[--text-a40]">
                    Al primo accesso nel pannello al customer è chiesto di indicate la tipologia di account. Questo
                    valore viene usato per mostrare contenuti promozionali adeguati durante la Trial. Poi viene
                    confermato in fase in d'ordine.
                  </p>
                </div>

                <pre className="bg-[--accent-l35] text-[--accent] px-1">{customer.declared_type}</pre>
              </div>
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.account.limits.title")}</div>
              <div className="sectionDesc">{t("settings.sections.account.limits.desc.customer")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                label={t("input.label.maxDomainsAvailable")}
                hint={
                  <div>
                    <TranslatedString subs={{ resourcesCustomer: customer.domains }}>
                      input.hint.activeNow
                    </TranslatedString>
                    <br />
                    <br />
                  </div>
                }
                name="max_domains"
                onChange={setFormFieldValue}
                value={formData.max_domains}
                errors={formErrors.max_domains}
                type="number"
                min={-1}
                step={1}
                required
              />

              <Input
                label={t("input.label.maxAccountsAvailable8")}
                hint={
                  <TranslatedString
                    subs={{
                      total: customer.total_email_accounts,
                      gb8: customer.email_accounts_8gb,
                      gb25: customer.email_accounts_25gb,
                      postmaster: customer.domains_postmaster_only,
                    }}
                  >
                    input.hint.activeNowFull
                  </TranslatedString>
                }
                name="max_email_accounts"
                onChange={this.setMaxLimits.bind(this)}
                value={formData.max_email_accounts}
                errors={formErrors.max_email_accounts}
                type="number"
                min={-1}
                step={1}
                required
              />

              <Input
                label={t("input.label.maxAccountsAvailable25")}
                hint={
                  <TranslatedString subs={{ resourcesCustomer: customer.email_accounts_25gb }}>
                    input.hint.activeNow
                  </TranslatedString>
                }
                name="max_email_accounts_25gb"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_25gb}
                errors={formErrors.max_email_accounts_25gb}
                min={-1}
                max={this.state.maxEmailAccountsSelected === -1 ? 999999 : this.state.maxEmailAccountsSelected}
                step={1}
                required
              />

              <Input
                label={t("input.label.maxAccountsAvailable50")}
                hint={
                  <TranslatedString subs={{ resourcesCustomer: customer.email_accounts_50gb }}>
                    input.hint.activeNow
                  </TranslatedString>
                }
                name="max_email_accounts_50gb"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_50gb}
                errors={formErrors.max_email_accounts_50gb}
                min={-1}
                max={this.state.maxEmailAccountsSelected === -1 ? 999999 : this.state.maxEmailAccountsSelected}
                step={1}
                required
              />

              <Input
                label={t("input.label.maxAccountsAvailable100")}
                hint={
                  <TranslatedString subs={{ resourcesCustomer: customer.email_accounts_100gb }}>
                    input.hint.activeNow
                  </TranslatedString>
                }
                name="max_email_accounts_100gb"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_100gb}
                errors={formErrors.max_email_accounts_100gb}
                min={-1}
                max={this.state.maxEmailAccountsSelected === -1 ? 999999 : this.state.maxEmailAccountsSelected}
                step={1}
                required
              />

              <Input
                label={t("input.label.maxArchiveAvailable")}
                hint={
                  <TranslatedString subs={{ resourcesCustomer: customer.email_accounts_archive }}>
                    input.hint.activeNow
                  </TranslatedString>
                }
                name="max_email_accounts_archive"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_archive}
                errors={formErrors.max_email_accounts_archive}
                min={-1}
                max={this.state.maxEmailAccountsSelected === -1 ? 999999 : this.state.maxEmailAccountsSelected}
                step={1}
                required
              />

              <Select
                label={t("input.label.maxAccountsSize")}
                components={{ DropdownIndicator }}
                name="max_email_quota"
                options={quotasWithout50MB}
                errors={
                  formErrors.max_email_quota &&
                  "Ci sono domini o email che hanno il limite superiore a questo. Modificali manualmente per prosegure."
                }
                onChange={setFormFieldValue}
                value={formData.max_email_quota}
                isSearchable={false}
                clearable={false}
              />

              <Input
                label={t("input.label.maxDeliveryFree")}
                name="max_delivery_account_free"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_delivery_account_free}
                errors={formErrors.max_delivery_account_free}
                min={0}
                step={1}
                required
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.catchAll.title")}</div>
              <div className="sectionDesc">{t("settings.sections.catchAll.desc.customer")}</div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.can.haveCatchAll")}
                name="catch_all"
                checked={formData.catch_all}
                onChange={setFormFieldValue}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.canEditOutbound.title")}</div>
              <div className="sectionDesc">{t("settings.sections.canEditOutbound.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.canEditOutboundLimits")}
                name="can_edit_outbound_limits"
                checked={formData.can_edit_outbound_limits}
                onChange={setFormFieldValue}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="flex items-center gap-2 settingTitle">
                {t("settings.sections.tracemail21DaysLimitDefault.title")}
              </div>
              <div className="sectionDesc">{t("settings.sections.tracemail21DaysLimitDefault.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Toggle
                className="inputFull2"
                label={t("input.label.tracemail21DaysLimitDefault")}
                name="domain_limit_tracemail_21_days_default"
                checked={formData.domain_limit_tracemail_21_days_default}
                errors={formErrors.domain_limit_tracemail_21_days_default}
                onChange={setFormFieldValue}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
